document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.section-header');
  if (!header) return;

  function onScroll() {
    if (window.scrollY > 40) {
      header.classList.add('vybe-header--scrolled');
    } else {
      header.classList.remove('vybe-header--scrolled');
    }
  }

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
});
